var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcHistory = function SvgIcHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.637 29.333 16 29.333m.882-18.87a1.333 1.333 0 1 0-2.667 0v6.462c0 .47.247.905.65 1.145l5.027 2.999a1.333 1.333 0 1 0 1.366-2.29l-4.376-2.611z",
    clipRule: "evenodd"
  })));
};
export default SvgIcHistory;